import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import useGetMe from '../api/queries/me/useGetMe';

export const useShowParentAccountAdminLayout = () => {
  const { data: me } = useGetMe();

  return {
    showParentAccountAdminLayout:
      !!me?.permissions.includes(AccountsPermissions.VIEW_CHILD_ACCOUNTS) &&
      (me?.user?.originalAccountId
        ? me.user.originalAccountId === me.user.account.id
        : false),
  };
};
